export default __webpack_public_path__ + "static/media/profilepic.6e2a6faf.jpeg";